import { Component } from '@angular/core';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-terms-and-conditions-to-read',
  templateUrl: './terms-and-conditions-to-read.component.html',
  styleUrls: ['./terms-and-conditions-to-read.component.scss']
})
export class TermsAndConditionsToReadComponent {
  isEnvironmentDevelopment: boolean = environment.development ? true : false
}
